import { MainLayoutContainer } from "components/Layout";
import { useAnswersList } from "./useAnswersList";
import CustomTable from "components/Table/CustomTable";
import { TABLE_ACTIONS, SortOrder } from "helpers/constants";
import { Avatar, Chip } from "@mui/material";
import { getAmericanDateTime } from "utils/Datetime";

export const AnswersList = () => {
  const {
    loading,
    organizationId,
    surveyId,
    submissions,
    error,
    surveyName,
    handleActionClick,
    handleDelete,
    deleteSubmissionOpen,
    setDeleteSubmissionOpen,
    submissionToDelete,
  } = useAnswersList();

  const tableData = submissions.map((submission) => ({
    submission_id: submission.submissionId,
    user_name: submission.user?.name || "Anonymous User",
    user_picture: submission.user?.picture_url,
    user_id: submission.user?.user_id,
    created_at: submission.created_at,
    answer_count: submission.answerCount,
  }));

  return (
    <MainLayoutContainer
      title={`Answers: ${surveyName || "Loading..."}`}
      loading={loading}
      error={error ? { message: error.message || "Error loading answers" } : undefined}
    >
      <CustomTable
        entities={tableData}
        handleActionClick={handleActionClick}
        fieldToFilter={(row: any, filterText: string) =>
          row.user_name.toLowerCase().includes(filterText.toLowerCase()) ||
          (row.created_at && getAmericanDateTime(row.created_at).toLowerCase().includes(filterText.toLowerCase()))
        }
        columns={[
          {
            id: "user",
            label: "User",
            value: (row: any) => (
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {row.user_picture ? (
                  <Avatar
                    src={row.user_picture}
                    alt={row.user_name}
                    sx={{ width: 32, height: 32 }}
                  />
                ) : (
                  <Avatar sx={{ width: 32, height: 32 }}>
                    {row.user_name[0].toUpperCase()}
                  </Avatar>
                )}
                <span>{row.user_name}</span>
              </div>
            ),
          },
          {
            id: "date",
            label: "Date",
            value: (row: any) =>
              row.created_at ? getAmericanDateTime(row.created_at) : "N/A",
          },
          {
            id: "answer_count",
            label: "Answers",
            value: (row: any) => (
              <Chip
                label={row.answer_count}
                size="small"
                color="primary"
                variant="outlined"
              />
            ),
          },
          { id: "actions", value: "" },
        ]}
        isSelectable={false}
        allowedMenuItems={[TABLE_ACTIONS.VIEW, TABLE_ACTIONS.DELETE]}
        extraActionItems={[]}
        idColumn={"submission_id"}
        sortDefault={SortOrder.desc}
        sortDefaultField={"created_at"}
        enableCardViewInSmallDevices={true}
      />
    </MainLayoutContainer>
  );
};
